//npm run build::loadtest
export const environment = Object.freeze({
    production: false,
    gateWayUrl: "https://gatewayapi.devinfinitylearn.in",
    commServiceUrl: "https://comservice.devinfinitylearn.in",
    semServiceUrl:
        "https://7ea24po66tlh7nxzstre6rslhi0uzkje.lambda-url.ap-south-1.on.aws",
    captchaSiteKey: "6LfSKrorAAAAALgCIJWzbndUFUSsQmv_A32b1j5w",
    ROLE_IDS: {
        EVALUATOR: 69,
    },
});
  